import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { DefaultContainedButton } from "@assets/buttons";
import { textCut } from "@assets/utils/check";
import MenuCaseView from "@components/CompDashboard/DashboardMainHeader/DashboardHeaderLeft/MenuCaseView";
import images from "@app/images";
import PopperLabel from "@components/CompDashboard/PopperLabel";

const ADFilterDialog = ({
  open,
  onClose,
  advertiserCheck,
  adCheck,
  onChange,
  adData,
}) => {
  const { ad, advertiser, img, imgName } = adData.target;
  const { img_banners } = adData;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={"lg"}
    >
      <Grid sx={{ height: 500, overflow: "hidden" }}>
        <DialogTitle id="alert-dialog-title">
          <Grid container>
            <Grid
              container
              justifyContent="space-around"
              alignItems="center"
              sx={{
                flexGrow: 1,
                height: 42,
                pl: 1.5,
                pr: 1.5,
                bgcolor: "grey.400",
                borderRadius: "10px",
                width: 700,
              }}
            >
              <MenuCaseView
                value={advertiser}
                adType="advertiser"
                text="광고주 전체"
                adFunc={advertiserCheck}
                cut={10}
                width={209.5}
              />
              <img src={images.icn_arrowLeft.default} alt=">" />
              <MenuCaseView
                value={ad}
                adType="ad"
                text="광고상품 전체"
                adFunc={adCheck}
                cut={15}
                width={209}
              />
              <img src={images.icn_arrowLeft.default} alt=">" />
              <MenuCaseView
                value={img}
                adType="img"
                text="이미지 전체"
                imgName={imgName}
                cut={10}
                width={209.5}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent sx={{ height: "338px" }}>
          <Grid container justifyContent="center" alignItems="center">
            <Grid container direction="column" sx={{ height: "100%" }}>
              <Grid
                container
                justifyContent="center"
                alignContent="center"
                sx={{
                  pb: 2,
                  pt: 2,
                  flex: 1,
                  overflow: "scroll",
                  minHeight: "280",
                }}
              >
                <Grid
                  sx={{
                    flex: 1,
                    borderRight: "1px solid #EEEEEF",
                    height: "initial",
                    overflow: "scroll",
                    pl: 1.5,
                    pr: 1.5,
                  }}
                >
                  <PopperLabel
                    active={advertiser === 0 ? true : false}
                    onClick={onChange}
                    title="광고주 전체보기"
                  />

                  {adData.advertiser_list.map((view, index) => {
                    return (
                      <PopperLabel
                        key={view[0].advertiser_id}
                        active={
                          advertiser === view[0].advertiser_id ? true : false
                        }
                        num={view[0].advertiser_id}
                        title={textCut(view[0].advertiser_name, 12)}
                        onClick={onChange}
                      />
                    );
                  })}
                </Grid>
                <Grid
                  sx={{
                    flex: 1,
                    borderRight: "1px solid #EEEEEF",
                    overflow: "scroll",
                    pl: 1.5,
                    pr: 1.5,
                    height: "initial",
                  }}
                >
                  <PopperLabel
                    active={ad === 0 ? true : false}
                    type="ad"
                    onClick={onChange}
                    title="광고상품 전체보기"
                  />
                  {adData.length !== 0 &&
                    adData.ad_list.map((view, index) => {
                      return (
                        <PopperLabel
                          key={view.ad_id}
                          type="ad"
                          active={ad === view.ad_id ? true : false}
                          num={view.ad_id}
                          title={textCut(view.title, 14)}
                          onClick={onChange}
                        />
                      );
                    })}
                </Grid>
                <Grid
                  sx={{
                    flex: 1,
                    height: "100%",
                    overflow: "scroll",
                    pl: 1.5,
                    pr: 1.5,
                  }}
                >
                  <PopperLabel
                    active={img === null ? true : false}
                    type="ad"
                    onClick={() => onChange(null, "img")}
                    title="이미지 전체보기"
                  />
                  {img_banners.length === 0 || img_banners === undefined ? (
                    <></>
                  ) : (
                    img_banners.map((view, index) => {
                      return (
                        <PopperLabel
                          key={view.ad_id}
                          type="ad"
                          active={img === view.ad_id ? true : false}
                          num={view.ad_id}
                          title={textCut(`${view.ad_id} / 
                                          ${
                                            view.img_name === undefined ||
                                            !view.img_name
                                              ? "이미지명 없음"
                                              : textCut(view.img_name, 10)
                                          }
                                          `)}
                          onClick={() =>
                            onChange(
                              view.ad_id,
                              "img",
                              `${
                                view.img_name === undefined || !view.img_name
                                  ? "이미지명 없음"
                                  : textCut(view.img_name, 10)
                              }`
                            )
                          }
                        />
                      );
                    })
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 0 }}>
          <Grid container justifyContent="center" alignItems="center">
            <Grid sx={{ width: 210, pb: 2, pt: 2 }}>
              <DefaultContainedButton
                color="primary"
                fullWidth={true}
                height={56}
                borderColor="primary.main"
                fontWeight={500}
                onClick={onClose}
                text={
                  <Typography
                    textAlign="center"
                    variant="h3"
                    component="div"
                    fontWeight={500}
                  >
                    {"확인"}
                  </Typography>
                }
              />
            </Grid>
          </Grid>
        </DialogActions>
      </Grid>
    </Dialog>
  );
};

export default ADFilterDialog;
